import { gql } from 'apollo-boost';

const CHANGE_NAME_MUTATION = gql`
  mutation CHANGE_NAME($firstName: String!, $lastName: String!) {
    changeName(firstName: $firstName, lastName: $lastName)
  }
`;

export default CHANGE_NAME_MUTATION;
